module.exports = __webpack_public_path__ + "img/磯田烈至.ed5d70ba.jpg";